import React from 'react';
import { ClaimTabProps } from '../claim-registration';

const MasterReserves: React.FC<ClaimTabProps> = ({
  claim,
  includeNext,
  includeBack,
  navigateNext,
  navigateBack,
}) => {
  return (
    <div className="bg-white p-6 rounded-lg">
      <h2 className="text-xl font-semibold mb-4">Master Reserves</h2>
      <p className="text-gray-500">Master Reserves content coming soon...</p>
    </div>
  );
};

export default MasterReserves;
